import {
  calculateColumnWidth,
  mapColumnTypes,
} from "@/react/components/table/columns";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import { JOB_STATES } from "@/react/features/jobs/constants";
import { CheckCircleIcon } from "@8x8/oxygen-icon";
import CloseCircleIcon from "@8x8/oxygen-icon/icons/CloseCircleIcon";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      {
        ...getColumnDef(schema.fields.jobType, "Type"),
      },
      {
        ...getColumnDef(schema.fields.name, "Name"),
        customCell: ({ getValue }) => <strong> {getValue()} </strong>,
      },
      {
        ...getColumnDef(schema.fields.userId, "User"),
      },
      {
        ...getColumnDef(schema.fields.state, "State"),
        customCell: ({ getValue }) => {
          let message = getValue();
          if (getValue() === JOB_STATES.SUCCEEDED) {
            return <CheckCircleIcon color={"green"} />;
          }
          if (getValue() === JOB_STATES.FAILED) {
            return <CloseCircleIcon color={"red"} />;
          }
          return <strong>{message}</strong>;
        },
      },
      {
        ...getColumnDef(schema.fields.failureReason, "Failure Reason"),
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
